// QrCodeAMC.js - parseur du code 2D (QR / DataMatrix) de l'attestation mutuelle AMC.
//
// Port FIDELE de la logique legacy WinForms TransCAM :
//  - F:\SV\PROJETDOTNET\_recovery_claude\snap_inline_wrappers_20260625_180746\teleservices\frmLectQrCode.cs
//      * branche typeLecture.AMC (parseAMC)     ~lignes 507-547
//      * table traduirecodebarre                ~lignes 746-859
//      * getDomaineConventionQrCode             ~lignes 678-722
//  - F:\SV\PROJETDOTNET\TransCAM_Library\AnnuaireAMCService.cs
//      * getTypeConvPourSpecialite              ~ligne 184
//
// Module PUR : aucun import de config / axios / Vue. Importable directement sous Node.
// Convention projet : francais sans accents, UTF-8 sans BOM.

// -----------------------------------------------------------------------------
// traduireCodeBarre
// -----------------------------------------------------------------------------
// Corrige la frappe AZERTY brouillee des douchettes (clavier QWERTY interprete
// en AZERTY). Port a l'identique du Select Case legacy "traduirecodebarre".
// Cas par defaut = caractere conserve tel quel.
//
// Ne sont volontairement PAS traduits (commentaire legacy JC 2020) :
//   < , > , ~ , [ , | , ` , ç;ç , ^ , à , ] , } , £ , µ , ù , §
//
// Remarque : la table legacy renvoie "?" & Asc(c) & "?" pour tout caractere non
// mappe qui n'appartient pas aux plages conservees (lettres b..y minuscules,
// B..Y majuscules, chiffres et ponctuations listees). On reproduit ce comportement.
export function traduireCodeBarre(entree) {
    if (entree === null || entree === undefined) {
        return '';
    }
    let sortie = '';
    for (let i = 0; i < entree.length; i++) {
        const c = entree.charAt(i);
        // Premier Select Case (sur le caractere)
        switch (c) {
            case '¨': // trema isole (touche morte AZERTY)
                sortie += '{';
                continue;
            case '£': // livre sterling
                sortie += '}';
                continue;
            case '%':
                sortie += '"';
                continue;
            case 'a':
                sortie += 'q';
                continue;
            case 'm':
                sortie += ';';
                continue;
            case ',':
                sortie += 'm';
                continue;
            case 'q':
                sortie += 'a';
                continue;
            case 'w':
                sortie += 'z';
                continue;
            case 'z':
                sortie += 'w';
                continue;
            // Case "A" est commente dans le legacy -> A tombe dans le Case Else
            case 'M':
                sortie += ':';
                continue;
            case 'Q':
                sortie += 'A';
                continue;
            case 'W':
                sortie += 'Z';
                continue;
            case 'Z':
                sortie += 'W';
                continue;
            case ';':
                sortie += ',';
                continue;
            case '?':
                sortie += 'M';
                continue;
            case 'è': // e accent grave
                sortie += '7';
                continue;
            case 'é': // e accent aigu
                sortie += '2';
                continue;
            case 'ç': // c cedille
                sortie += '9';
                continue;
            case '=':
            case '+':
                // Case "=", "+", "," -> conserve tel quel (le "," est deja capte plus haut)
                sortie += c;
                continue;
            default:
                break;
        }
        // Plages conservees telles quelles : b..l, n..p, r..v, x..y
        if (
            (c >= 'b' && c <= 'l') ||
            (c >= 'n' && c <= 'p') ||
            (c >= 'r' && c <= 'v') ||
            (c >= 'x' && c <= 'y')
        ) {
            sortie += c;
            continue;
        }
        // Plages conservees telles quelles : B..L, N..P, R..V, X..Y
        if (
            (c >= 'B' && c <= 'L') ||
            (c >= 'N' && c <= 'P') ||
            (c >= 'R' && c <= 'V') ||
            (c >= 'X' && c <= 'Y')
        ) {
            sortie += c;
            continue;
        }
        // Case Else -> Select Case Asc(c)
        const code = c.charCodeAt(0);
        switch (code) {
            case 32:
                sortie += ' ';
                break;
            case 33:
                sortie += '/';
                break;
            case 34:
                sortie += '3';
                break;
            case 38:
                sortie += '1';
                break;
            case 39:
                sortie += '4';
                break;
            case 40:
                sortie += '5';
                break;
            case 41:
                sortie += '-';
                break;
            case 45:
                sortie += '6';
                break;
            case 48:
                sortie += ')';
                break;
            case 49:
                sortie += '!';
                break;
            case 50:
                sortie += '@';
                break;
            case 51:
                sortie += '#';
                break;
            case 52:
                sortie += '$';
                break;
            case 53:
                sortie += '%';
                break;
            case 55:
                sortie += '&';
                break;
            case 56:
                sortie += '*';
                break;
            case 58:
                sortie += '.';
                break;
            case 59:
                sortie += ',';
                break;
            case 95:
                sortie += '8';
                break;
            case 224:
                sortie += '0';
                break;
            case 231:
                sortie += '9';
                break;
            case 232:
                sortie += '7';
                break;
            case 233:
                sortie += '2';
                break;
            case 249:
                sortie += "'";
                break;
            case 13:
                sortie += '\r';
                break;
            case 10:
                sortie += '\n';
                break;
            default:
                sortie += '?' + code + '?';
                break;
        }
    }
    return sortie;
}

// -----------------------------------------------------------------------------
// parseAMC
// -----------------------------------------------------------------------------
// Format : AMC#<version>#<numeroAMC>#<CSR>#<numeroAdherent>#<typeConvention>/...
// split sur "#" : index 2=numeroAMC, 3=CSR, 4=numeroAdherent, 5..=typeConvention
// (concatenes par "#") jusqu'au premier "/".
// Regle legacy : si numeroAdherent.length > 8 -> le vider ("").
// Si moins de 6 champs, on renvoie l'objet avec des champs vides.
export function parseAMC(texte) {
    const vide = { numeroAMC: '', csr: '', numeroAdherent: '', typeConvention: '' };
    if (texte === null || texte === undefined) {
        return vide;
    }
    const splChamps = String(texte).split('#');
    // Legacy : acces a splChamps(5) -> il faut au moins 6 champs (indices 0..5)
    if (splChamps.length < 6) {
        return vide;
    }
    const numeroAMC = splChamps[2];
    const csr = splChamps[3];
    let numeroAdherent = splChamps[4];
    if (numeroAdherent.length > 8) {
        numeroAdherent = ''; // sinon ca plante (regle legacy)
    }
    // Reconstruction de la convention : splChamps(5) & "#" & splChamps(6..)
    let totalConv = splChamps[5];
    for (let i = 6; i < splChamps.length; i++) {
        totalConv = totalConv + '#' + splChamps[i];
    }
    // Coupe au premier "/". Si absent, on garde la chaine entiere (Mid legacy).
    const finConv = totalConv.indexOf('/');
    const typeConvention = finConv === -1 ? totalConv : totalConv.substring(0, finConv);
    return { numeroAMC, csr, numeroAdherent, typeConvention };
}

// -----------------------------------------------------------------------------
// getDomaineConventionQrCode
// -----------------------------------------------------------------------------
// Port de getDomaineConventionQrCode (frmLectQrCode.cs). Traduit une lettre de
// domaine encodee dans le QR en famille de convention interne.
function getDomaineConventionQrCode(strDom) {
    if (strDom === null || strDom === undefined) {
        return '';
    }
    switch (String(strDom).toUpperCase()) {
        case 'I':
            return 'AMI';
        case 'K':
            return 'AMM';
        case 'Y':
            return 'AMY';
        case '2':
            return 'AMO';
        case '3':
            return 'AMP';
        case 'A':
            return 'AUDI';
        case 'C':
            return 'CSTE';
        case 'D':
            return 'DENT';
        case 'E':
            return 'EXTE';
        case 'H':
            return 'HOSP';
        case 'L':
            return 'LABO';
        case '1':
            return 'LPPS';
        case 'G':
            return 'MEDG';
        case 'S':
            return 'MEDS';
        case 'O':
            return 'OPTI';
        case 'P':
            return 'PHAR';
        case 'R':
            return 'RADL';
        case 'F':
            return 'SAGE';
        case 'T':
            return 'TRAN';
        default:
            return '';
    }
}

// -----------------------------------------------------------------------------
// getTypeConvPourSpecialite
// -----------------------------------------------------------------------------
// Port de AnnuaireAMCService.getTypeConvPourSpecialite. Choisit le type de
// convention (2 caracteres) selon le domaine du PS.
// Le legacy derive domainePS de l'etat CPS ; ici on l'injecte en parametre pour
// garder le module pur.
// Regles :
//  - split du champ convention sur "#" ;
//  - pour chaque sous-champ de plus de 2 caracteres, les caracteres a partir de
//    la position 3 (1-based) sont des lettres de domaine ; "*" = tous domaines,
//    sinon on compare getDomaineConventionQrCode(domaine) a domainePS ;
//  - un sous-champ de <= 2 caracteres est renvoye tel quel.
export function getTypeConvPourSpecialite(qrCodeTypeConv, domainePS) {
    if (qrCodeTypeConv === null || qrCodeTypeConv === undefined) {
        return '';
    }
    let typeConv = qrCodeTypeConv;
    const splConv = String(qrCodeTypeConv).split('#');
    const dom = domainePS === null || domainePS === undefined ? '' : String(domainePS);
    for (let i = 0; i < splConv.length; i++) {
        const champ = splConv[i];
        if (champ.length > 2) {
            // idDomaine de 3 a longueur (1-based) -> indices 2 a longueur-1 (0-based)
            for (let idDomaine = 3; idDomaine <= champ.length; idDomaine++) {
                const domaine = champ.charAt(idDomaine - 1);
                if (domaine === '*') {
                    typeConv = champ.substring(0, 2);
                } else if (dom === getDomaineConventionQrCode(domaine)) {
                    typeConv = champ.substring(0, 2);
                    break;
                }
            }
        } else {
            typeConv = champ;
        }
    }
    return typeConv;
}
